import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'

const LastLocationContext = React.createContext<
    RouteComponentProps['location'] | undefined
>(undefined)

export default LastLocationContext
